import { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import styles from '../../assets/scss/components/Dropdown.module.scss';

export default function Dropdown({ label, value, options, onChange, placeholder = 'Chọn...' }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    const selected = options.find((o) => o.value === value);

    return (
        <div className={styles.dropdown} ref={ref}>
            {label && <label className={styles.dropdownLabel}>{label}</label>}
            <button
                className={`${styles.dropdownTrigger}${open ? ` ${styles.dropdownTriggerOpen}` : ''}`}
                onClick={() => setOpen(!open)}
                type="button"
            >
                <span className={selected ? styles.dropdownTriggerValue : styles.dropdownTriggerPlaceholder}>
                    {selected ? selected.label : placeholder}
                </span>
                <ChevronDown size={16} className={`${styles.dropdownChevron}${open ? ` ${styles.dropdownChevronOpen}` : ''}`} />
            </button>

            {open && (
                <div className={styles.dropdownMenu}>
                    {options.map((option) => (
                        <button
                            key={option.value}
                            className={`${styles.dropdownOption}${option.value === value ? ` ${styles.dropdownOptionActive}` : ''}`}
                            onClick={() => {
                                onChange(option.value);
                                setOpen(false);
                            }}
                            type="button"
                        >
                            <span className={styles.dropdownOptionLabel}>
                                {option.dot && (
                                    <span className={styles.dropdownOptionDot} style={{ background: option.dot }} />
                                )}
                                {option.label}
                            </span>
                            {option.value === value && <Check size={16} className={styles.dropdownOptionCheck} />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
